
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bbz-cream pt-20">
      <div className="text-center px-4">
        <h1 className="text-5xl md:text-6xl font-playfair font-semibold mb-4 text-bbz-text">404</h1>
        <div className="h-1 w-20 bg-bbz-green mx-auto mb-6"></div>
        <p className="text-xl md:text-2xl text-bbz-text mb-6">
          Cette page n'a pas été trouvée
        </p>
        <p className="text-bbz-text/80 mb-8 max-w-md mx-auto">
          La page que vous recherchez n'existe pas ou a été déplacée.
          Revenez à l'accueil pour continuer votre navigation.
        </p>
        <Link 
          to="/" 
          className="btn-primary inline-block"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
